import { Oval, Puff, TailSpin, ThreeDots } from "react-loader-spinner";

export default function LoadingScreen() {
  
  return <>
  
  <div className="loader-container fixed
   inset-0 d-flex align-items-center justify-content-center bg-opacity-25">
     
        <div className=" w-100 vh-100 z-100 d-flex align-items-center justify-content-center">
        <div className="flex items-center space-x-2">
      <TailSpin height={90} width={80} color="#f59b5b" />
      <span className="pt-2 text-sm text-gray-600">Loading...</span>
    </div>
          </div>
          </div>
      
   
  
  </>
}
